
//import arrow from './assets/arrow.png'
import React, { useEffect } from 'react';
import Footer from './Footer';
import CardServizi from './CardServizi';
//import CardPartner from './CardPartner';
import Head from './Header'
function Servizi() {
    //const [mostra, setMostra] = useState(false)
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    return (<>
        <Head></Head>
        <div className="main-header">
            <div className="container">
                <div className="flex">
                    <div className="f1">
                        <div className="col sm-mid">
                            <h2>Futura Care nasce per offrire alle famiglie un innovativo servizio di assistenza alle persone che necessitano di interventi sanitari</h2>
                            <span className="blue-line">
                            </span>
                            <p className="margin">Garantiamo: Centrale operativa 24/24 H, Assistenza alla persona Domiciliare, Assistenza Domiciliare Infermieristica </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <div className="main-header main-headers">
            <div className="container containers colonna flex-cp servizi">
                <div className="text-center m-p">
                    <h2 align="center">Servizi offerti</h2>
                    <span className="blue-line">

                    </span>
                </div>
                <div className="flex row between scrolling-wrapper-flexbox">
                    <CardServizi />
                </div>
            </div>
        </div>

        <Footer></Footer>  </>
    );
}


export default Servizi;